import React from 'react';
import LinkProvider from '../../../CommonComponents/LinkProvider/LinkProvider';
import ArrowRightBlueIcon from '../../../../static/icons/arrow-right-blue-icon.svg';
import { onImageLoadError } from '../../../utils/helper';
import { INFORMATION_DATA, getGenreLabel } from '../../constants/information';
import './InformationHome.scss';

const InformationHome = () => {
  const sortedInformations = INFORMATION_DATA?.sort(
    (a, b) => new Date(b?.releaseDate) - new Date(a?.releaseDate)
  );

  const urlNoImg = 'https://www.owndays.com/images/information/no-image.jpg';

  const onScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const formatDate = dateString => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}.${month}.${day}`;
  };

  const getInformationList = () => {
    return sortedInformations?.slice(0, 4).map((item, index) => (
      <a
        key={`information-home-card-${index}`}
        className="od-information-home__card"
        href={`/sg/en/information/${item?.id}`}
        target="_self"
        onClick={onScrollToTop}
      >
        <img
          alt={item?.storeName ? item?.storeName : item?.title}
          className="od-information-home__card__image"
          src={item?.cover || urlNoImg}
          onError={e => onImageLoadError(e)}
        />
        <div>
          <span className="od-information-home__card__day">
            {formatDate(item?.releaseDate)} ｜ {getGenreLabel(item?.genre)}
          </span>
          <p className="od-information-home__card__desc">{item?.title}</p>
        </div>
      </a>
    ));
  };

  return (
    <div className="od-information-home">
      <div className="od-information-home__container">
        <div>
          <h2 className="od-information-home__header">Information</h2>
          <LinkProvider
            className="od-information-home__see-all-btn--pc"
            target="_self"
            to="/information"
            onClick={onScrollToTop}
          >
            See all the Information
            <img alt="" src={ArrowRightBlueIcon} />
          </LinkProvider>
        </div>

        <div className="od-information-home__list">{getInformationList()}</div>

        <div className="od-information-home__actions">
          <LinkProvider className="button" target="_self" to="/information" onClick={onScrollToTop}>
            See all the Information
          </LinkProvider>
        </div>
      </div>
    </div>
  );
};

export default InformationHome;
